import { doc, getDoc } from 'firebase/firestore'

import { db } from 'utils/firebase'

import { DiscoverContent } from 'types/discoverContent'

export const fetchDiscoverContent = async (): Promise<DiscoverContent> => {
  const contentRef = doc(db, '_admin', 'discoverContent')
  const discoverContent = (await getDoc(contentRef)).data()
  if (!discoverContent) throw new Error('No discover content found.')

  return discoverContent as DiscoverContent
}
